import { Chip } from "@mui/material";

type ThemeVariant = "primary" | "secondary" | "error" | "warning" | "info" | "success" | "default";

const statusToTheme: Record<string, ThemeVariant> = {
  'Em aberto': 'info',
  'Em andamento': 'warning',
  'Finalizado': 'success',
};

export interface StatusProps {
  status: string;
  theme?: ThemeVariant;
}

export function Status({ status, theme }: StatusProps) {
  const normalizedStatus = status.toLowerCase().trim();
  const selectedTheme = theme || statusToTheme[normalizedStatus] || 'default';

  return <Chip label={status} color={selectedTheme} variant="outlined" />;
}